const SIZES = [11, 13, 19];

export default function extractGamedata(gamedata) {
  const transformedGames = gamedata.games;
  const games = [];
  let lastId = 0, lastTime = 0;
  for (let i = 0; i < transformedGames.id.length; i++) {
    const flattenedMoves = transformedGames.moves[i];
    const moves = [];
    for (let j = 0; j < flattenedMoves.length; j += 2) {
      moves.push(flattenedMoves.substring(j, j + 2));
    }
    const id = parseInt(transformedGames.id[i], 10) + lastId;
    lastId = id;
    const timeSeconds = parseInt(transformedGames.time[i], 10) + lastTime;
    lastTime = timeSeconds;
    games.push({
      id,
      moves,
      time: timeSeconds * 1000,
      players: [transformedGames.players[2 * i], transformedGames.players[2 * i + 1]],
      winner: parseInt(transformedGames.winner[i], 10),
      swapped: parseInt(transformedGames.swapped[i], 10),
      size: SIZES[parseInt(transformedGames.size[i], 10)],
    });
  }
  return {games, players: gamedata.players};
}



// WEBPACK FOOTER //
// ./src/extractGamedata.js